export const fetchUsers = (roleId, search = '') =>
    fetch(`${process.env.REACT_APP_API_URL}/api/app/search/users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roleId,
            search
        })
    })
        .then(resp => resp.json())
        .then(resp => resp.results)
        .catch(console.error);
